import { __awaiter, __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { Router } from "@angular/router";
import { ComponentService } from "../../../services/component.service";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { LocationStrategy } from "@angular/common";
import { SharedHttp } from "../../../services/http-client.service";
import { QrScannerModalComponent } from "../../qr-scanner-modal";
import { QrScannerModalService } from "../../qr-scanner-modal/qr-scanner-modal.service";
import { UtilityService } from "../../../services/utility.service";
import { WebClientService } from "../../../services/webclient-settings.service";
/**
 * Withdraw Wallet Modal Component
 */
let WithdrawWalletAudModalComponent = class WithdrawWalletAudModalComponent {
    constructor(sanitizer, router, httpClient, compService, location, qrScannerService, themeService, utilityService, webSettingsService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.qrScannerService = qrScannerService;
        this.themeService = themeService;
        this.utilityService = utilityService;
        this.webSettingsService = webSettingsService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.amount = null;
        this.minAmount = 0;
        this.maxAmount = 0;
        this.address = '';
        this.maxValidAmount = true;
        this.minValidAmount = true;
        this.validAddress = true;
        this.sendButtonDisabled = true;
        this.fee = 0;
        this.fixedFee = 0;
        this.minBalance = false;
        this.bankAccount = '';
        this.validBankAccount = true;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.getMarketSettings(false).then(() => this.checkMinBalance());
            this.intervalId = setInterval(() => {
                this.getWallet();
            }, 15000);
        });
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    close() {
        this.modal.destroy();
    }
    checkValidation() {
        return __awaiter(this, void 0, void 0, function* () {
            this.checkMinBalance();
            let validatedAddress;
            if (!this.data.walletData.currency.fiat) {
                if (this.webSettingsService.applySettings('ADDRESS_VALIDATION')) {
                    yield this.utilityService.validateAddress(this.address, this.data.walletData.currency.verboseId).then(result => {
                        validatedAddress = result.validDepositAddress;
                    });
                }
                else {
                    validatedAddress = true;
                }
                if (this.address === '') {
                    this.validAddress = true;
                    this.previousAddress = '';
                    this.amountReceive = null;
                    this.fee = 0;
                    return;
                }
                if (!validatedAddress) {
                    this.validAddress = false;
                }
                if ((this.address !== '' && this.address !== this.previousAddress) || (this.amount && this.amount !== this.previousAmount)) {
                    if (validatedAddress) {
                        this.validAddress = true;
                    }
                    let addressAmount = this.amount ? this.amount : 0;
                    this.httpClient.get('wallet/isaddressinternal?address=' + this.address + '&cryptocurrency=' + this.data.walletData.currency.verboseId + '&amount=' + addressAmount).subscribe((data) => __awaiter(this, void 0, void 0, function* () {
                        yield this.getMarketSettings(data['addressInternal']['internal']);
                        this.fixedFee = data['addressInternal']['internal'] ? data['internalFee'] : data['externalFee'];
                        this.fee = this.fixedFee;
                        this.previousAddress = this.address;
                        this.previousAmount = this.amount;
                        this.checkValidation();
                    }));
                }
            }
            if (this.minBalance) {
                return;
            }
            if (!this.amount || typeof this.amount === 'undefined' || this.amount <= 0) {
                this.minValidAmount = true;
                this.maxValidAmount = true;
                this.amountReceive = null;
                this.fee = 0;
                this.sendButtonDisabled = true;
                return;
            }
            if (!this.data.walletData.currency.fiat) {
                if (this.amount && this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 8) {
                    this.amount = Number(this.amount.toFixed(18));
                }
            }
            else {
                if (this.amount && this.amount.toString().split('.').length > 1 && this.amount.toString().split('.')[1].length > 2) {
                    this.amount = Number(this.amount.toFixed(2));
                }
                yield this.getFiatFees(this.amount, this.data.walletData.currency.verboseId.toLowerCase());
            }
            if (this.amount * 100000000 < this.minAmount * 100000000) {
                this.minValidAmount = false;
                this.maxValidAmount = true;
                this.amountReceive = null;
                this.sendButtonDisabled = true;
                return;
            }
            if (this.amount * 100000000 > this.data.walletData.spendableTotal * 100000000 || this.amount * 100000000 > this.maxAmount * 100000000) {
                this.maxValidAmount = false;
                this.minValidAmount = true;
                this.amountReceive = null;
                this.sendButtonDisabled = true;
                return;
            }
            this.maxValidAmount = true;
            this.minValidAmount = true;
            this.fee = this.fixedFee;
            this.amountReceive = this.sub(this.amount, this.fee);
            if (!this.data.walletData.currency.fiat) {
                this.sendButtonDisabled = !validatedAddress;
            }
            else {
                this.validBankAccount = true;
                if (!this.accountNumber || this.accountNumber === '') {
                    this.sendButtonDisabled = true;
                    return;
                }
                if (!this.bankName || this.bankName === '') {
                    this.sendButtonDisabled = true;
                    return;
                }
                return this.sendButtonDisabled = false;
            }
        });
    }
    sendCoinsOrFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.sendButtonDisabled || this.minBalance) {
                return;
            }
            const concData = "bsb:" + this.bsb + "|" + "accountNumber:" + this.accountNumber + "|" + "receiver:" + this.user.name + "|" + "bankName:" + this.bankName;
            const withdrawData = {
                customerWalletId: this.data.walletData.verboseId,
                amount: this.amount,
                amountReceive: this.amountReceive,
                toAddress: concData,
                passphrase: this.data.walletData.passphrase,
                currency: this.data.walletData.currency.verboseId,
                fee: this.fee,
                internalTransferFee: this.internalFee
            };
            this.close();
            this.compService.openModal(AuthenticationWalletModalComponent, {
                withdrawData: withdrawData,
                accountData: this.data.accountData,
                walletData: this.data.walletData,
                authenticated: false,
                isFiat: this.data.walletData.currency.fiat,
                type: this.data.walletData.currency.fiat ? 'fiat_withdrawal' : 'crypto_withdrawal'
            });
        });
    }
    getMaxAmount() {
        if (this.address !== '' || this.data.walletData.currency.fiat) {
            this.amount = this.data.walletData.spendableTotal;
            this.checkValidation();
        }
    }
    getBankLookup() {
        const bsb = document.getElementById("bsb").value;
        if (bsb !== '') {
            this.bankName = null;
            this.httpClient.get('wallet/banklookup?bsb=' + bsb).subscribe((data) => {
                if (data['bank_name']) {
                    this.bankName = data['bank_name'];
                    this.checkValidation();
                }
            });
        }
    }
    getWallet() {
        this.httpClient.get('wallet/getwallet?customerWalletId=' + this.data.walletData.verboseId).subscribe((data) => {
            if (data['wallet']) {
                this.data.walletData.spendableTotal = data['wallet']['spendableTotal'];
            }
        });
    }
    validateBankAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.utilityService.validateBankAccount(this.bankAccount).then(result => {
                this.validBankAccount = true;
                this.bankAccount = result.formatedBankAccount;
            });
        });
    }
    checkMinBalance() {
        this.minBalance = this.data.walletData.spendableTotal * 100000000 < this.minAmount * 100000000;
    }
    getMarketSettings(isInternal = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let userType = this.user.user_type_id.type;
            let isIndividual = this.user.is_company_user ? 0 : 1;
            let meansOfPayment = 'bank_slip';
            let orderType = isInternal ? 'internal_wallet_withdrawal' : 'wallet_withdrawal';
            let data = yield this.httpClient.get('wallet/getmarketsettings?baseCurrency=' + this.data.walletData.currency.verboseId.toLowerCase() + '&meanOfPayment=' + meansOfPayment + '&userType=' + userType + '&orderType=' + orderType + '&isIndividual=' + isIndividual).toPromise();
            this.minAmount = Number(data['min_amount']);
            this.maxAmount = Number(data['max_amount']);
        });
    }
    getFiatFees(amount, currency) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = yield this.httpClient.get('wallet/fiatfees?amount=' + amount + '&currency=' + currency).toPromise();
            this.fixedFee = data['externalFee'];
        });
    }
    openQRScanner() {
        this.compService.openModal(QrScannerModalComponent, {
            enableScanner: true
        });
        this.qrScannerService.getScanResult().subscribe((result) => {
            if (typeof result !== 'undefined' && result !== null) {
                let arr;
                let address;
                if (result.indexOf(':') !== -1) {
                    arr = result.split(':');
                    address = arr[1];
                }
                else {
                    address = result;
                }
                if (address.indexOf('?') !== -1) {
                    arr = address.split('?');
                    address = arr[0];
                }
                this.address = address;
                this.qrScannerService.scanDone(null);
            }
        });
    }
    sub(b, c) {
        let tens = [10, 100, 1000, 10000, 100000, 1000000, 10000000, 100000000, 1000000000, 10000000000, 100000000000, 1000000000000, 10000000000000, 100000000000000, 1000000000000000, 10000000000000000, 100000000000000000, 1000000000000000000];
        let finalString;
        let b1 = b.toString().split(".");
        let b1_max = 0;
        if (b1.length == 2) {
            b1_max = b1[1].length;
        }
        let c1 = c.toString().split(".");
        let c1_max = 0;
        if (c1.length == 2) {
            c1_max = c1[1].length;
        }
        let max_len = 0;
        let max_val = 0;
        if (b1_max > c1_max) {
            max_val = tens[b1_max - 1];
            max_len = b1_max;
        }
        else {
            max_len = c1_max;
            max_val = tens[c1_max - 1];
        }
        let fv = 0;
        if (max_len == 0) {
            max_val = 1;
            fv = b - c;
        }
        else {
            finalString = ((((b * max_val) - (c * max_val)) / max_val).toFixed(max_len));
            return finalString;
        }
        finalString = fv.toString();
        return finalString;
    }
};
WithdrawWalletAudModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: QrScannerModalService },
    { type: WebsiteThemeService },
    { type: UtilityService },
    { type: WebClientService }
];
WithdrawWalletAudModalComponent = __decorate([
    Component({
        selector: 'ecd-withdraw-wallet-aud-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./withdraw-wallet-aud-modal.component.html")).default
    })
], WithdrawWalletAudModalComponent);
export { WithdrawWalletAudModalComponent };
